"use client";

import { useEffect } from "react";

import type { PostMfaAnalyzeWidgetData } from "#app/_api/external-fund-transfer-service/post-mfa-analyze-widget";
import AuthVendorWidget from "#app/_ui/components/authvendor/AuthVendorWidget";
import { Dialog, DialogContent, DialogOverlay, DialogPortal } from "#ui/dialog";

interface CheckImageWidgetModalProps {
  open: boolean;
  widgetData: PostMfaAnalyzeWidgetData;
  onSuccess: (event: any) => void;
  onError: (event: any) => void;
  onCancel: () => void;
}

export function CheckImageWidgetModal({
  open,
  widgetData,
  onSuccess,
  onError,
  onCancel,
}: CheckImageWidgetModalProps) {
  useEffect(() => {
    function handleCancelMessage(event: MessageEvent) {
      try {
        // Check if event origin matches current window origin (case insensitive)
        if (
          window.location.origin.toLowerCase() !== event.origin?.toLowerCase()
        ) {
          return;
        }

        const messageData =
          typeof event.data === "string" ? JSON.parse(event.data) : event.data;

        if (
          messageData.Type === "Router" &&
          messageData.Detail === "MfaCancelAction"
        ) {
          onCancel();
        }
      } catch (error) {
        console.error(
          "Message parsing error (expected for some messages):",
          error,
        );
      }
    }

    window.addEventListener("message", handleCancelMessage);

    return () => {
      window.removeEventListener("message", handleCancelMessage);
    };
  }, [onCancel]);

  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onCancel()}>
      <DialogPortal>
        <DialogOverlay>
          <DialogContent
            aria-describedby={undefined}
            className="max-w-3xl rounded-none border-none bg-white p-0 shadow-none"
          >
            <AuthVendorWidget
              accessToken={widgetData.widgetToken.accessToken}
              companyId={widgetData.widgetToken.companyId}
              policyId={widgetData.widgetToken.policyId}
              widgetContainerSelector="skWidget"
              extraParameters={{
                UserId: widgetData.authVendorId,
                IntrasessionSessionToken: widgetData.sessionValue,
                Login: widgetData.loginId,
              }}
              onSuccess={onSuccess}
              onError={onError}
            />
          </DialogContent>
        </DialogOverlay>
      </DialogPortal>
    </Dialog>
  );
}
